import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=5f8e51f5&scoped=true"
import script from "./SingleChoice.vue?vue&type=script&lang=js"
export * from "./SingleChoice.vue?vue&type=script&lang=js"
import style0 from "./SingleChoice.vue?vue&type=style&index=0&id=5f8e51f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e51f5",
  null
  
)

export default component.exports